import { Link } from "react-router-dom";

const Setting = () => {
  const mainSettings = [
    {
      title: "Departments",
      desc: "Organize teams by function and manage department structure.",
      color: "bg-blue-100",
      path: "/company-settings/departments",
    },

    {
      title: "Levels",
      desc: "Define role levels and manage salary structure clearly.",
      color: "bg-pink-100",
      path: "/company-settings/levels",
    },

    {
      title: "Positions",
      desc: "Create job positions and manage each position description.",
      color: "bg-cyan-100",
      path: "/company-settings/position",
    },

    {
      title: "Media",
      desc: "Upload and manage company media assets with clear descriptions.",
      color: "bg-green-100",
      path: "/company-settings/media",
    },

    {
      title: "Admins",
      desc: "Manage admin groups, members, and permissions.",
      color: "bg-blue-100",
      path: "/company-settings/admins",
    },
    {
      title: "Permissions",
      desc: "Create and manage module access permissions assigned to each position.",
      color: "bg-pink-100",
      path: "/company-settings/permission",
    },

    {
      title: "Tools",
      desc: "Register company tools, assign them to staff, and keep the inventory accurate.",
      color: "bg-emerald-100",
      path: "/company-settings/tools",
    },

    {
      title: "Roles",
      desc: "Define organization roles and maintain role descriptions.",
      color: "bg-purple-100",
      path: "/company-settings/role",
    },

    {
      title: "Org.Charts",
      desc: "Build and manage organizational hierarchy with positions and reporting structure.",
      color: "bg-blue-100",
      path: "/company-settings/org-chart",
    },

    {
      title: "Manage Branches",
      desc: "Create and manage branch names, addresses, and branch status.",
      color: "bg-[#EDFCF7]",
      path: "/company-settings/branches",
    },
  ];

  const moreSettings = [
    { title: "Plans & subscription", desc: "View your current plan, billing date, employee pricing, and plan benefits.", color: "bg-blue-100", path: "/company-settings/subscription" },
    { title: "Recruitment", desc: "Configure your careers page, publish vacancies, and manage the hiring pipeline.", color: "bg-indigo-100", path: "/company-settings/recruitment" },
    {
      title: "Notifications",
      desc: "Send email and in-app notifications to staff, departments, or levels.",
      color: "bg-orange-100",
      path: "/company-settings/notifications",
    },
    {
      title: "Staff Birthdays",
      desc: "View and celebrate staff birthdays throughout the year.",
      color: "bg-rose-100",
      path: "/company-settings/staff-birthdays",
    },
    {
      title: "Work Anniversaries",
      desc: "Track and celebrate employee work anniversaries and milestones.",
      color: "bg-amber-100",
      path: "/company-settings/work-anniversaries",
    },
    {
      title: "Holidays",
      desc: "Create, schedule, and notify staff about company and public holidays.",
      color: "bg-teal-100",
      path: "/company-settings/holidays",
    },
  ];

  const SettingCard = ({ item }) => (
    <Link to={item.path} className="block min-w-0 h-full">
      <div
        className={`${item.color} h-full min-h-[112px] rounded-xl p-3 shadow-sm transition hover:shadow-md sm:min-h-[128px] sm:p-4 lg:p-6`}
      >
        <h2 className="mb-1.5 break-words text-sm font-bold leading-5 text-black sm:mb-2 sm:text-base">{item.title}</h2>
        <p
          className="text-[11px] leading-4 text-gray-600 sm:text-sm sm:leading-5"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {item.desc}
        </p>
      </div>
    </Link>
  );

  return (
    <div>
      <div className="min-h-screen p-4 font-Nunito sm:p-6">
        {/* Title */}
        <h1 className="text-2xl font-bold mb-6">Company Settings</h1>
        {/* Main Settings Grid */}
        <div className="mb-10 grid w-full grid-cols-2 gap-3 min-[480px]:grid-cols-3 sm:gap-4 lg:min-w-[200px] lg:grid-cols-5 lg:gap-6">
          {mainSettings.map((item, i) => (
            <SettingCard
              key={i}
              item={item}
            />
          ))}
        </div>

        {/* More Settings Section */}
        <div className="mt-12">
          <h2 className="text-xl font-bold mb-6">More Settings</h2>
          <div className="grid w-full grid-cols-2 gap-3 min-[480px]:grid-cols-3 sm:gap-4 lg:min-w-[200px] lg:grid-cols-3 lg:gap-6">
            {moreSettings.map((item, i) => (
              <SettingCard
                key={i}
                item={item}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setting;
